module.exports = __webpack_public_path__ + "assets/img/Smart-Cricket-in-a-Ludimos-Smart-Lane.f7d46d54.jpg";